export const isProduction = (process.env.REACT_APP_BASE_API_URL || '').includes('api.madkhol.com');

/** Running against a local backend — `REACT_APP_ENVIRONMENT=local`, or an API on localhost. False on dev, stg and prod. */
export const isLocal =
  process.env.REACT_APP_ENVIRONMENT === 'local' ||
  /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/.test(process.env.REACT_APP_BASE_API_URL || '');
